import { useBaseAPI } from 'apiServices/baseAPI';

export function useUserFhirAPI({ patientID }) {
  return useBaseAPI({
    method: 'GET',
    route: `user/fhir/Patient/${patientID}`,
    data: {},
  });
}
